import { IAlign } from '../align'

const align: IAlign = {
    mainContainerRowAlign: 'center',
    mainContainerColumnAlign: 'center',
}

export { align }
